import request from "@/router/axios";
export const list = () => {
  return request({
    url: `/api/jc/clinical/rule/list`,
    method: "post",
    data: {
      orderBy: "projectId",
      isDesc: false,
    },
  });
};
export const listByCode = (code) => {
  return request({
    url: `/api/jc/clinical/rule/list`,
    method: "post",
    data: {
      filterParams: [{
        name: "code",
        value: code
      }],
      orderBy: "createTime",
      isDesc: false,
    },
  });
};
export const add = (data) => {
  return request({
    url: `/api/jc/clinical/rule/add`,
    method: "post",
    data,
  });
};
export const edit = (data) => {
  return request({
    url: `/api/jc/clinical/rule/edit`,
    method: "post",
    data,
  });
};
export const remove = (ids) => {
  return request({
    url: `/api/jc/clinical/rule/del`,
    method: "post",
    params: {
      ids,
    },
  });
};
export const saveRules = (data) => {
  return request({
    url: `/api/jc/clinical/rule/saveRule`,
    method: "post",
    data,
  });
};
export const saveMergeRule = (data) => {
  return request({
    url: `/api/jc/clinical/rule/saveMergeRule`,
    method: "post",
    data,
  });
};